<payee-chip-dropdown
  [placeholder]="'Ügyfélazonosító szám'"
  [selected]="control.value"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="control.patchValue(null)"
>
  <payee-form-field width="wide">
    <span payee-label>Hitelező neve</span>
    <input
      payee-input
      [formControl]="control"
      (paste)="closeAfterPaste()"
    />
  </payee-form-field>
</payee-chip-dropdown>
